module.exports = __webpack_public_path__ + "static/media/heart13.e95efab6.svg";